<script>
    export let data_with_tags_versions = [];
    export let model_versions = [];

    let selectedDataWithTags;
    let trainResponse, trainLoading;
    let selectedModel;
    let selectModelResponse, selectLoading;

    import FilenameSelector from "../../components/FilenameSelector.svelte";
    import SectionButton from "../../components/SectionButton.svelte";
    import SectionTitle from "../../components/SectionTitle.svelte";
    import ResultMessage from "../../components/ResultMessage.svelte";
    import { refreshVersion } from "../../stores.js";

    import { getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../../api/client.js";
    import TrainProgress from "../../components/TrainProgress.svelte";

    const context = getContext(api_info);
    async function trainModel() {
        if (selectedDataWithTags) {
            trainResponse = undefined;
            trainLoading = true;
            trainResponse = await fetchWithAuthentication(
                context,
                "/train_model/",
                {
                    data_with_tags_collection_name: selectedDataWithTags.value,
                }
            );
            trainLoading = false;
        }
    }

    async function selectModel() {
        if (selectedModel) {
            selectModelResponse = undefined;
            selectLoading = true;
            selectModelResponse = await fetchWithAuthentication(
                context,
                "/select_model_version/",
                {
                    model_version: selectedModel.value,
                }
            );
            selectLoading = false;
            refreshVersion(context);
        }
    }
</script>

<h3>4. โมเดล</h3>
<form class="form-horizontal">
    <SectionTitle title="เทรนโมเดล" />
    <FilenameSelector
        label="ข้อมูลคำร้องติดป้ายกำกับ"
        id="section4_data_with_tags"
        items={data_with_tags_versions}
        bind:value={selectedDataWithTags}
    />
    <SectionButton
        label="เทรนข้อมูล"
        disabled={!selectedDataWithTags}
        loading={trainLoading}
        on:click={trainModel}
    >
        <ResultMessage response={trainResponse} />
    </SectionButton>
    <TrainProgress />

    <SectionTitle title="เลือกโมเดล" />
    <FilenameSelector
        label="เวอร์ชันโมเดล"
        id="section4_model"
        items={model_versions}
        bind:value={selectedModel}
    />
    <SectionButton
        label="เลือกโมเดล"
        disabled={!selectedModel}
        loading={selectLoading}
        on:click={selectModel}
    >
        <ResultMessage response={selectModelResponse} />
    </SectionButton>
</form>
